export default {"src":"/_next/static/media/brown-globe.b7b25c8e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};